import SelectorBobinasPage from "../../pages/legacy/seleccionBobinas/SelectorBobinasPage";

const route = {
  key: "selectorBobinas.detailNoDataArea",
  path: "/legacy/selector-bobinas/document/:id",
  component: SelectorBobinasPage,
  private: true,
  layout: "main",
  icon: "faLayerGroup",
  group: "sales",
  order: 21.52,
  permission: "legacy.salesorder.read"
};

export default route;
